import type { ManagedPersonStatus } from "#shared/managePeopleContract.ts";

export type PersonHeaderAction = "deactivate" | "reactivate" | "sendInvite" | "resendInvite" | "remove";

const ACTIONS_BY_STATUS: Record<ManagedPersonStatus, PersonHeaderAction[]> = {
    active: ["deactivate", "remove"],
    created: ["sendInvite", "remove"],
    invited: ["resendInvite", "remove"],
    deactivated: ["reactivate", "remove"],
    nonSeat: ["remove"]
};

const SELF_GUARDED_ACTIONS = new Set<PersonHeaderAction>(["deactivate", "remove"]);

export function resolvePersonHeaderActions(status: ManagedPersonStatus, isSelf: boolean): PersonHeaderAction[] {
    const actions = ACTIONS_BY_STATUS[status];

    return isSelf ? actions.filter(action => !SELF_GUARDED_ACTIONS.has(action)) : [...actions];
}
